import { app_url } from "app_config"
import Breadcrumb from "components/Common/Breadcrumb"
import React, { useEffect, useState } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import {
  Container,
  CardBody,
  Card,
  Col,
  Row,
} from "reactstrap"
 
import ServiceTasks from "./ServiceTasks"
import UtrCacPayeVat from "./UtrCacPayeVat"

const ReportsIndex = () => {
  const { tab_name } = useParams()
  const navigate = useNavigate() 

  const [tabs, setTabs] = useState(["services-task", "UTR-CAC-PAYE-VAT"])

  useEffect(() => {
    if (!tab_name && tabs.length) {
      navigate(`${app_url}report/reports/${tabs[0]}`)
    }
  }, [tab_name, tabs])


  return (
    <div>
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb title={"Dashboard"} breadcrumbItem={"Reports"} />
          <div>
            <Row>
              <Col md={2} className="pe-1">
                <Card>
                  <CardBody className=" rounded custom_side_nav p-2">
                    {tabs.map(tab => {
                      return (
                        <div key={tab} className="mb-2">
                          <Link
                            to={`${app_url}report/reports/${tab?.toLowerCase()}`}
                            className={`side_navlink text-capitalize ${tab?.toLowerCase() === tab_name && "bg-white fw-bold"
                              }`}
                          >
                            {tab.replaceAll("-", " ")}
                          </Link>
                        </div>
                      )
                    })}
                  </CardBody>
                </Card>
              </Col>
              <Col md={10}>
                <Card>
                  <CardBody>
                    {
                      (tab_name === tabs[0]) &&
                      <ServiceTasks />
                    }
                    {
                      (tab_name === tabs[1].toLowerCase()) &&
                      <UtrCacPayeVat />
                    }
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default ReportsIndex
